export { View as RiskPoints } from './view'
